import { t } from 'i18next';
import { toNumber } from 'lodash';

const SIGN_REDKM_MINUTES = "′";
const SIGN_REDKM_SECONDS = "″";

const UNIT_RED_KM = "Red. km";
const UNIT_MIL_RED = "Mil. red.";


export const convertSpeed = (metric?: "metric" | 'imperial', distance: number = 0) => {

    if (metric === 'metric') {
        return String(((distance * 5) / 1000).toFixed(1)).concat(`  km`)
    }
    if (metric === 'imperial') {
        return String(((distance * 5) / 1609).toFixed(1)).concat(` mi`)
    }
    return ''
}

export const convertSpeedToNb = (metric?: "metric" | 'imperial', distance: number = 0) => {

    if (metric === 'metric') {
        return ((distance * 5) / 1000)
    }
    if (metric === 'imperial') {
        return ((distance * 5) / 1609)
    }
    return 0
}


export function getSpeedForChart(speed: number, unit: string) {
    
    switch (unit) {
        case "min/km":
            return (speed > 0) ? (200 / speed).toFixed(1) : '0';
        case "min/mi":
            return (speed > 0) ? (200 / (speed * 0.621371)).toFixed(1) : '0';
        case "m/min":
            return (speed > 0) ? (speed * 5).toFixed(0) : '0';
        case "km/h":
            return (speed > 0) ? (0.3 * speed).toFixed(1) : '0';
        case "m/s":
            return (speed > 0) ? (speed / 12).toFixed(1) : '0';
        case "Red. km":
            return (speed > 0) ? (200 / speed).toFixed(2) : '0';
        case "mph":
            return (speed > 0) ? (0.3 * speed * 0.621371).toFixed(1) : '0';
        case "Mil. red.":
            return (speed > 0) ? (200 / (speed * 0.621371)).toFixed(2) : '0';
        default:
            return '0'

    }
}
export function getSpeedTooltipForChart(speedConverted: number, unit: string, includeUnit: boolean = true) {
    let SIGN_REDKM_MINUTES = "′";
    let SIGN_REDKM_SECONDS = "″";
    let sFormatted = ''

    let translationsUnits: any = [];
    translationsUnits["km/h"] = t('units:km\/h');
    translationsUnits["mph"] = t('units:mph');

    let result = '';

    switch (unit) {
        case "min/km":
            result = speedConverted + (includeUnit ? " min/km" : "");
            break;
        case "m/min":
            result = speedConverted + (includeUnit ? t("units:m\/min") : "");
            break;
        case "min/mi":
            result = speedConverted + (includeUnit ? " min/mi" : "");
            break;
        case "km/h":
            result = speedConverted + (includeUnit ? " " + translationsUnits["km/h"] : "");
            break;
        case "m/s":
            result = speedConverted + (includeUnit ? " m/s" : "");
            break;
        case "Red. km":
            if (speedConverted % 1 == 0) {
                sFormatted = Math.floor(speedConverted) + "′00″0";
            } else {
                var seconds = (speedConverted - Math.floor(speedConverted)) * 60;
                var secondsStr = Math.floor(seconds).toString().padStart(2, "0");
                var secondTenths = 0;
                if (seconds % 1 != 0) {
                    secondTenths = Math.round((seconds - Math.floor(seconds)) * 10);
                }
                sFormatted = Math.floor(speedConverted) + SIGN_REDKM_MINUTES + secondsStr + SIGN_REDKM_SECONDS + secondTenths;
            }
            result = sFormatted;
            break;
        case "mph":
            result = speedConverted + (includeUnit ? " " + translationsUnits["mph"] : "");
            break;
        case "Mil. red.":
            if (speedConverted % 1 == 0) {
                sFormatted = Math.floor(speedConverted) + "′00″";
            } else {
                var seconds = (speedConverted - Math.floor(speedConverted)) * 60;
                var secondsStr = Math.floor(seconds).toString().padStart(2, "0");
                var secondTenths = 0;
                if (seconds % 1 != 0) {
                    secondTenths = Math.round((seconds - Math.floor(seconds)) * 10);
                }
                sFormatted = Math.floor(speedConverted) + SIGN_REDKM_MINUTES + secondsStr + SIGN_REDKM_SECONDS + secondTenths;
            }
            result = sFormatted;
            break;
    }

    return result;
}

export function getConvertedSpeed(speed: number, unit: string) {
    let vitesse = toNumber(getSpeedForChart(speed, unit))
    return getSpeedTooltipForChart(vitesse, unit)
}

export function formatMetricIntoImperialDistance(meters: number, imperialDistanceMilesOnly = false) {

    // miles = Math.floor(meters /1609.34); 
    // furlongs = Math.floor((meters - (miles * 1609.34)) / 201.168 ) ; 
    // yards = Math.floor( (meters - miles * 1609 - furlongs * 201.168)/0.9144);
    if (imperialDistanceMilesOnly) {
        return (meters / 1600).toFixed(2) + ` ${t('units:meters')} `;
    }

    let miles = Math.floor(meters / 1600);
    let furlongs = Math.floor((meters - (miles * 1600)) / 200);
    let yards = Math.floor((meters - miles * 1600 - furlongs * 200) / 0.9);

    let res = "";
    if (miles > 0) res += miles + ` ${t('units:miles')} `;
    if (furlongs > 0) res += furlongs + ` ${t('units:furlongShort')} `;
    if (yards > 0) res += yards + 'y ';

    return res;
}

export function convertStrideLength(unitSystem?: 'imperial' | 'metric', value?: number | null) {
    if (!value || value === 0) {
        return 0;
    }
    if (unitSystem == "imperial") {
        return ((value * 3.28) / 20).toFixed(2);
    } else {
        return (value / 20).toFixed(2);
    }
}
export function convertStrideFrequency(value?: number | null) {
    if (!value || value === 0) {
        return 0;
    }
    return (value / 50).toFixed(1);
}
export function getDatabaseSpeed(speedConverted: number, unit: string, unitSystem: string = "metric") {

    if (unitSystem == "imperial") {
        if (unit == "km/h") unit = "mph";
        if (unit == "min/km") unit = "min/mi";
        if (unit == "Red. km") unit = "Mil. red.";
    }


    switch (unit) {
        case "min/km":
        case "km/h":
            return Math.round(speedConverted / 0.3);

        case "Red. km":
            let value = String(speedConverted)
            value.trim();
            var minutes = parseInt(value.split(SIGN_REDKM_MINUTES)[0]);
            var seconds = parseInt((value.split(SIGN_REDKM_MINUTES)[1]).split(SIGN_REDKM_SECONDS)[0]);
            var secondTenths = (value.split(SIGN_REDKM_MINUTES)[1]).split(SIGN_REDKM_SECONDS).length == 2 && '' != (value.split(SIGN_REDKM_MINUTES)[1]).split(SIGN_REDKM_SECONDS)[1] ? (value.split(SIGN_REDKM_MINUTES)[1]).split(SIGN_REDKM_SECONDS)[1] : 0;
            var minPerKm = (minutes * 60 + seconds + toNumber(secondTenths) / 100) / 60;
            return 200 / minPerKm;


        case "min/mi":
        case "mph":
            return Math.round(speedConverted / (0.3 * 0.621371));

        case "Mil. red.":
            let valueMil = String(speedConverted)

            valueMil.trim();
            var _minutes = valueMil.split(SIGN_REDKM_MINUTES)[0];
            var _seconds = (valueMil.split(SIGN_REDKM_MINUTES)[1]).split(SIGN_REDKM_SECONDS)[0];
            var _secondTenths = (valueMil.split(SIGN_REDKM_MINUTES)[1]).split(SIGN_REDKM_SECONDS).length == 2 && '' != (valueMil.split(SIGN_REDKM_MINUTES)[1]).split(SIGN_REDKM_SECONDS)[1] ? (valueMil.split(SIGN_REDKM_MINUTES)[1]).split(SIGN_REDKM_SECONDS)[1] : 0;

            var _minPerKm = ((toNumber(_minutes) * 60 + toNumber(_seconds) + toNumber(_secondTenths)) / 100) / 60;

            return 200 / (_minPerKm * 0.621371);

        case "m/min":
            return (speedConverted / 5);
        default:
            return 0
    }
}
export function toCelsius(temp: number, unit:'F' | 'C') {
    if (unit.toUpperCase() === 'F') {
        return (temp - 32) * 5 / 9;
    }
    return temp; // already in Celsius
}